/** Only reader filters are forwarded, never auth/callback parameters. */
export const readerQuery = (search: string) => {
	const params = new URLSearchParams(search)
	const safe = new URLSearchParams()
	for (const key of ['q', 'search', 'page', 'areas', 'types'])
		for (const value of params.getAll(key)) safe.append(key, value)
	return safe.toString() ? `?${safe}` : ''
}

/** A trusted iframe may synchronize a reader path, never an external or dashboard URL. */
export const readerLocationPath = (value: unknown) => {
	if (
		typeof value !== 'string' ||
		value.length > 4096 ||
		!/^\/docs(?:\/|\?|$)/.test(value) ||
		/[\\\u0000-\u0020]|%5c|%0[ad]/i.test(value)
	)
		return
	const url = new URL(value, 'https://reader.invalid')
	if (
		url.origin !== 'https://reader.invalid' ||
		!/^\/docs(?:\/|$)/.test(url.pathname)
	)
		return
	return `${url.pathname}${readerQuery(url.search)}`
}

/** A single browser-facing origin is shared by Admin, readers and authenticated announcements. */
export function contentServiceOrigin(base: string, parentOrigin: string) {
	const url = new URL(base)
	const loopback = (hostname: string) =>
		['localhost', '127.0.0.1', '[::1]'].includes(hostname)
	if (
		(url.protocol !== 'https:' &&
			!(url.protocol === 'http:' && loopback(url.hostname))) ||
		(loopback(url.hostname) && !loopback(new URL(parentOrigin).hostname)) ||
		url.username ||
		url.password ||
		url.pathname !== '/' ||
		url.search ||
		url.hash
	)
		throw new Error('Invalid content administration origin')
	return url.origin
}

/** Only a configured CMS origin receives the user's token. Never inherit the current query string. */
export function contentFrameUrl(
	base: string,
	token: string,
	parentOrigin: string,
	readerPath?: string
) {
	const url = new URL(contentServiceOrigin(base, parentOrigin))
	if (readerPath && !/^\/docs(?:\/|\?|$)/.test(readerPath))
		throw new Error('Invalid content reader path')
	url.pathname = readerPath ? '/reader/embed' : '/admin/embed'
	if (readerPath) url.searchParams.set('path', readerPath)
	url.searchParams.set('token', token)
	url.searchParams.set('parentOrigin', parentOrigin)
	return url.toString()
}
